import React from 'react';
// import './css/terms_condition.css';
import './css/styles.css';
class Cookies extends React.Component{
    render(){
        return(   
            <div  style={{padding:'20px',paddingTop:'80px'}}>
                <h3>AiPlex Cookies Policy</h3>
    <h5>About this cookie policy</h5>
    <p>This Cookie Policy explains what cookies are and how we use them. You should read this policy to understand what
        cookies are, how we use them, the types of cookies we use i.e., the information we collect using cookies and how
        that information is used and how to control the cookie preferences. For further information on how we use, store
        and keep your personal data secure, see our Privacy Policy. (Hyperlink here)
        You can at any time change or withdraw your consent from this page.</p>
    <p>Learn more about who we are, how you can contact us and how we process personal data in our Privacy Policy.</p>
    <h5>What are cookies?</h5>
    <p>
        Cookies are small text files that are used to store small pieces of information. The cookies are stored on your
        device when the website is loaded on your browser. These cookies help us make the website function properly,
        make the website more secure, provide better user experience, and understand how the website performs and to
        analyze what works and where it needs improvement.

    </p>
    <h5>How do we use cookies?</h5>
    <p>As most of the online services, our website uses cookies first-party and third-party cookies for a number of
        purposes. The first-party cookies are mostly necessary for the website to function the right way, and they do
        not collect any of your personally identifiable data.
    </p>
    <p>
        The third-party cookies used on our websites are used mainly for understanding how the website performs, how you
        interact with our website, keeping our services secure, providing advertisements that are relevant to you, and
        all in all providing you with a better and improved user experience and help speed up your future interactions
        with our website.
    </p>
    <h5>What types of cookies do we use?</h5>
    <p>Essential: Some cookies are essential for you to be able to experience the full functionality of our site. They
        allow us to maintain user sessions and prevent any security threats. They do not collect or store any personal
        information. For example, these cookies allow you to log-in to your account and add products to your basket and
        checkout securely.
    </p>
    <p>Statistics: These cookies store information like the number of visitors to the website, the number of unique
        visitors, which pages of the website have been visited, the source of the visit etc. These data help us
        understand and analyze how well the website performs and where it needs improvement.
    </p>
    <p>
        Marketing: Our website displays advertisements. These cookies are used to personalize the advertisements that we
        show to you so that they are meaningful to you. These cookies also help us keep track of the efficiency of these
        ad campaigns.

    </p>
    <p>The information stored in these cookies may also be used by the third-party ad providers to show you ads on other
        websites on the browser as well.
    </p>
    <p>Functional: These are the cookies that help certain non-essential functionalities on our website. These
        functionalities include embedding content like videos or sharing contents on the website on social media
        platforms.
    </p>
    <p>
        Preferences: These cookies help us store your settings and browsing preferences like language preferences so
        that you have a better and efficient experience on future visits to the website.
    </p>
    <h5>How can I control the cookie preferences?
    </h5>
    <p>
        Should you decide to change your preferences later through your browsing session, you can click on the “manage
        your consent” link situated above in this page. This will display the consent notice again enabling you to
        change your preferences or withdraw your consent entirely.

    </p>
    <p>In addition to this, different browsers provide different methods to block and delete cookies used by websites.
        You can change the settings of your browser to block/delete the cookies. To find out more out more on how to
        manage and delete cookies, visit wikipedia.org, www.allaboutcookies.org.
    </p>
</div>
            
             )
    }
}
export default Cookies